import { ICreateSection, ISectionListSearch } from "../../../../types/permissions/sectionInterface";
import api from "../../../../lib/api";


export const getSectionListApi = async (data: ISectionListSearch) => {
  return await api.get(`section/${data.page}/${data.pageLimit}?search=${data?.search ?? ""}`);
};

export const addSectionApi = async (data: ICreateSection) => {
  return await api.post(`section/`, data);
};